import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const Terms = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <SEO 
        title="Terms and Conditions - Legend Audiovisual Comics"
        description="Read Legend's terms and conditions to understand the rules and regulations for using our audiovisual comics platform."
        keywords="terms and conditions, user agreement, terms of service, Legend terms"
        url="https://visual-story-forge.emergent.host/terms"
        type="article"
      />
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/60 backdrop-blur-xl border-b border-[#FFB966]/10">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 group cursor-pointer">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-[#FFB966] to-[#FF8C42] blur-md opacity-50 group-hover:opacity-100 transition-opacity"></div>
                <div className="relative flex gap-0.5">
                  {[0, 1, 2].map((i) => (
                    <div key={i} className="w-1.5 h-10 bg-gradient-to-b from-[#FFB966] to-[#FF8C42] rounded-full transform rotate-12" style={{ marginLeft: i > 0 ? '2px' : '0' }}></div>
                  ))}
                </div>
              </div>
              <span className="text-2xl font-bold tracking-wider bg-gradient-to-r from-[#FFB966] to-[#FFC57D] bg-clip-text text-transparent">LEGEND</span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Terms and <span className="bg-gradient-to-r from-[#FFB966] to-[#FFC57D] bg-clip-text text-transparent">Conditions</span>
          </h1>
          <p className="text-gray-400 mb-12">Last updated: April 1, 2026</p>

          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">1. Acceptance of Terms</h2>
              <p className="leading-relaxed">
                By accessing and using the Legend app and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">2. Use License</h2>
              <p className="leading-relaxed mb-4">
                Permission is granted to temporarily download one copy of the materials on Legend for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose</li>
                <li>Attempt to decompile or reverse engineer any software</li>
                <li>Remove any copyright or proprietary notations</li>
                <li>Transfer the materials to another person</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">3. User Account</h2>
              <p className="leading-relaxed">
                You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">4. Content</h2>
              <p className="leading-relaxed">
                Our service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material. You are responsible for the content that you post on or through the service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">5. Intellectual Property</h2>
              <p className="leading-relaxed">
                The service and its original content, features and functionality are and will remain the exclusive property of Zing Technologies Inc. and its licensors. Our trademarks may not be used in connection with any product or service without prior written consent.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">6. Termination</h2>
              <p className="leading-relaxed">
                We may terminate or suspend your account and bar access to the service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever, including without limitation if you breach the Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">7. Limitation of Liability</h2>
              <p className="leading-relaxed">
                In no event shall Zing Technologies Inc., nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-white">8. Contact Us</h2>
              <p className="leading-relaxed">
                If you have any questions about these Terms, please contact us at:
                <br />
                <a href="mailto:legal@legendhq.com" className="text-[#FFB966] hover:underline">legal@legendhq.com</a>
              </p>
            </section>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-6 border-t border-white/5">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="text-gray-500 text-sm">
              © 2026 Zing Technologies Inc. All rights reserved.
            </div>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-gray-400 hover:text-[#FFB966] transition-colors">Privacy</Link>
              <Link to="/terms" className="text-gray-400 hover:text-[#FFB966] transition-colors">Terms</Link>
              <Link to="/contact" className="text-gray-400 hover:text-[#FFB966] transition-colors">Contact</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;